import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import MaskedInput from 'react-maskedinput';
import { Field, connect as formikConnect, getIn } from 'formik';
import './index.css';

// TODO: https://projectpine.atlassian.net/browse/FE-129

// wrapper around MaskedInput to spread the inner field values
// eslint-disable-next-line react/prop-types
const MaskedInputField = ({ field, ...props }) => <MaskedInput {...field} {...props} />;

/**
 * Input renders a Formik Field with our custom styles applied. Should not
 * be used directly, but through Input.
 */
const Input = ({
  name,
  className,
  formik,
  // eslint-disable-next-line react/prop-types
  mask,
  // eslint-disable-next-line react/prop-types
  error: errorText,
  isBorderless,
  ...otherProps
}) => {
  const error = errorText || getIn(formik.errors, name);
  const touched = getIn(formik.touched, name) || !!errorText;

  const shadowable = !isBorderless && touched;

  const classes = classNames(
    'Input',
    {
      'Input--invalid': shadowable && error,
      'Input--valid': shadowable && !error,
      'Input--borderless': isBorderless,
    },
    className,
  );
  const component = mask ? MaskedInputField : 'input';

  return (
    <div className={classes}>
      <Field
        id={name}
        name={name}
        component={component}
        mask={mask}
        className={`Input__input ${otherProps.classes.input}`}
        {...otherProps}
      />
    </div>
  );
};

Input.propTypes = {
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  isBorderless: PropTypes.bool,
  formik: PropTypes.object.isRequired,
  classes: PropTypes.shape({
    input: PropTypes.string,
  }),
};

Input.defaultProps = {
  className: '',
  isBorderless: false,
  classes: { input: '' },
};

const ConnectedInput = formikConnect(Input);

export default ConnectedInput;



// WEBPACK FOOTER //
// ../ui-components/components/InputField/index.jsx